// fetch polyfill for IE11 – https://dev.to/adrianbdesigns/how-to-polyfill-javascript-fetch-function-for-internet-explorer-g46
// POST
// async addPerson() {
//   const data = { name: 'Jessica', gender: 'f', age: 25 };

//   const response = await fetch(`https://example.com/people`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(data),
//   });

//   if(response.status !== 200) throw new Error('Server error.');

//   return response.json();
// }

// ====================================================
function removeFormErrors(theFormID) {
	let theForm = $('#' + theFormID);
	theForm.find('.tk-inputErrorMessage').remove();
	theForm.find('input, select, textarea').removeClass('tk-error');
}

function showInputErrorMessage(theFormID, theInputID, theMessage) {
	let theForm = $('#' + theFormID);
	let theInput = theForm.find("input[name='" + theInputID + "'], textarea[name='" + theInputID + "']"); // will select one or the other

	// if label exists attach to it for floating label
	let theLabel = theForm.find(`label[for='${theInputID}']`);
	if (theLabel.length && theMessage.length > 0) {
		theLabel.after(`<div class="tk-inputErrorMessage">${theMessage}</div>`);
	} else if (theMessage.length > 0) {
		theInput.after(`<div class="tk-inputErrorMessage">${theMessage}</div>`);
	}

	theInput.addClass('tk-error');
}

function showFormInputErrorMessage(theFormID, theInputID, theMessage) {
	// if label exists attach to it for floating label
	if ($(`#${theFormID} label[for='${theInputID}']`).length && theMessage.length > 0) {
		$(`#${theFormID} label[for='${theInputID}']`).after(`
			<div class="tk-inputErrorMessage">
				${theMessage}
			</div>`);
	} else if (theMessage.length > 0) {
		$(`#${theFormID} input[name='${theInputID}']`).after(`
				<div class="tk-inputErrorMessage">
					${theMessage}
				</div>`);
	}

	$(`#${theInputID}`).addClass('tk-error');
}

function isValidPhoneNumber(thePhone) {
	const theDigits = thePhone.replace(/\D/g, ''); // Remove all non-digits
	return theDigits.length >= 10;
}

function isValidEmail(theEmail) {
	let theRegEx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-.]+(?:\.[a-zA-Z0-9-]+)$/;

	if (theRegEx.test(theEmail)) {
		return true;
	}

	return false;
}

function isValidPassword(thePassword) {
	if (thePassword.length >= 12 && thePassword.length <= 72) {
		return true;
	}

	return false;
}

function isValidCreditCardNumber(theNumber) {
	const regex = new RegExp('^[0-9]{13,19}$'); //Check if the number contains only numeric value and is of between 13 to 19 digits
	if (!regex.test(theNumber)) {
		return false;
	}

	// LUHN Algorithim
	let theChecksum = 0; // running checksum total
	let theMultiplier = 1; // takes value of 1 or 2

	// Process each digit one by one starting from the last
	for (let i = theNumber.length - 1; i >= 0; i--) {
		let theCalc = 0;
		theCalc = Number(theNumber.charAt(i)) * theMultiplier; // Extract the next digit and multiply by 1 or 2 on alternative digits.

		// If the result is in two digits add 1 to the checksum total
		if (theCalc > 9) {
			theChecksum = theChecksum + 1;
			theCalc = theCalc - 10;
		}

		theChecksum = theChecksum + theCalc; // Add the units element to the checksum total
		theMultiplier = theMultiplier == 1 ? 2 : 1; // Switch the value of theMultiplier
	}

	//Check if it is divisible by 10 or not.
	return theChecksum % 10 == 0;
}

function isValidCreditCardDate(theDate, theDateToday = false) {
	const theRegEx = /^(01|02|03|04|05|06|07|08|09|10|11|12)\/20[2-9][0-9]$/;

	if (!theRegEx.test(theDate)) {
		return false;
	} else if (theDateToday) {
		const theDateNumber = theDate.split('/').reverse().join('') * 1;
		const theDateTodayNumber = theDateToday.split('/').reverse().join('') * 1;

		if (theDateNumber < theDateTodayNumber) {
			return false;
		}
	}

	return true;
}

function isValidCVCNumber(theCode) {
	if ((theCode.length == 3 || theCode.length == 4) && Number.isInteger(Number(theCode)) && Number(theCode) >= 0) {
		return true;
	}

	return false;
}

function formatPhoneNumber(theNumber) {
	theNumber = theNumber.trim();

	if (theNumber.length == 10) {
		let theNum1 = theNumber.slice(0, 3);
		let theNum2 = theNumber.slice(3, 6);
		let theNum3 = theNumber.slice(6, 10);
		theNumber = theNum1 + '-' + theNum2 + '-' + theNum3;
	} else if (theNumber.length == 11 && theNumber.slice(0, 1) == 1) {
		let theNum1 = theNumber.slice(1, 4);
		let theNum2 = theNumber.slice(4, 7);
		let theNum3 = theNumber.slice(7, 11);
		theNumber = theNum1 + '-' + theNum2 + '-' + theNum3;
	}

	return theNumber;
}

function escapeHtml(theString) {
	var map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;'
	};

	return theString.replace(/[&<>"']/g, function (m) {
		return map[m];
	});
}

/**
 * Base function to handle fetch calls to different endpoints
 * @param {string} url The full URL to make the fetch request to
 * @param {any} body The body content to be sent in the request
 * @param {object} headers The headers for the request
 * @param {boolean} debug Whether to enable debugging
 * @param {string} debugName Name to identify this call in debug logs
 * @returns {Promise<any>} JSON response from the fetch request
 */
async function baseFetchCall(theURL, theBody, theHeaders, isDebug = false, theDebugName = '') {
	if (isDebug) console.warn('DEBUGING: ', theDebugName); // We no longer break when debugging. So let the user know we have debug set for a function. so we can remember to remove the debug.

	const theResponse = await fetch(theURL, {
		method: 'POST',
		body: theBody,
		headers: theHeaders
	});

	const theClonedResponse = theResponse.clone(); //So we can get the error text if we get an error when trying to get the json.
	try {
		const theJSON = await theResponse.json();
		return theJSON;
	} catch (jsonError) {
		const theErrorText = await theClonedResponse.text();
		//insert theErrorText into an error log table.
		// if (isDebug) throw new Error(theErrorText);
		throw new Error(theErrorText);
	}
}

/**
 * This is function to make a post call to js-call.php
 * @param {string} theCurrentHost The current host of the application
 * @param {object} theObject The object that contains the function and data to be called in js-call.php
 * @param {string} theObject.function The function you are wanting to call in js-call
 * @param {object} theObject.theParams The paramaters to be passed to the js-call function you are posting to.
 * ie const theObject = {function:'fetchOrderAmounts', params:theParams}
 * @param {boolean} debug A way to debug the php code being executed.If debug = true we are able to see the error text in the console.
 * @returns JSON object returned from the POST request
 */

async function jsCallPost(theCurrentHost, theObject, debug = false) {
	return baseFetchCall(
		`${theCurrentHost}/webhooks/js-call.php`,
		JSON.stringify(theObject),
		{ 'Content-type': 'application/json; charset=UTF-8' },
		debug,
		theObject.function
	);
}

/**
 * This is function to make a post call to post-responder.php
 * @param {string} theCurrentHost The current host of the application
 * @param {string} theAction The function to call in post-responder.php
 * @param {object} theFormData The form data to be passed to the post-responder.php
 * @param {boolean} debug A way to debug the php code being executed.If debug = true we are able to see the error text in the console.
 * @returns JSON object returned from the POST request
 */
async function jsCallFormPost(theCurrentHost, theAction, theFormData, debug = false) {
	// Append the action/function identifier to the FormData
	theFormData.append('function', theAction);

	// Optionally append additional data to theFormData if needed
	// theFormData.append("additionalKey", "additionalValue");

	// Do not set 'Content-Type': 'multipart/form-data' header manually;
	// it will be set automatically by the browser, including the boundary parameter.
	return baseFetchCall(`${theCurrentHost}/webhooks/post-responder.php`, theFormData, {}, debug, theAction);
}

/**
 * This is function to make a post call to js-call-account.php
 * @param {string} theCurrentHost The current host of the application
 * @param {object} theObject The object that contains the function and data to be called in js-call.php
 * @param {string} theObject.function The function you are wanting to call in js-call
 * @param {object} theObject.theParams The paramaters to be passed to the js-call function you are posting to.
 * ie const theObject = {function:'fetchOrderAmounts', params:theParams}
 * @param {boolean} debug A way to debug the php code being executed.If debug = true we are able to see the error text in the console.
 * @returns JSON object returned from the POST request
 */
async function jsCallPostAccount(theCurrentHost, theObject, debug = false) {
	return baseFetchCall(
		`${theCurrentHost}/webhooks/js-call-account.php`,
		JSON.stringify(theObject),
		{ 'Content-type': 'application/json; charset=UTF-8' },
		debug,
		theObject.function
	);
}

/**
 * Attempts to download JSON files generated from the provided object, where each key-value pair represents a filename and its corresponding JSON string.
 * This function creates a downloadable link for each JSON string, initiates the download, and handles errors gracefully by collecting them into an array.
 *
 * @param {Object} theJsonStringObject - An object with properties where each key is intended as the filename and each value is a JSON string.
 *                                       The function attempts to create and download a JSON file for each key-value pair.
 *                                       Defaults to an empty object if no parameter is provided, resulting in no downloads.
 * @returns {Object} An object containing a boolean indicating overall success and an array of errors, if any occurred.
 *                   The structure is:
 *                   {
 *                     didSucceed: Boolean,  // true if all downloads succeeded without errors, false otherwise
 *                     errorArray: Array     // an array of Error objects, each representing a download failure
 *                   }
 */
const downloadJSONFilesWithStatus = (theJsonStringObject = {}) => {
	const theLink = document.createElement('a');
	const errors = [];

	for (const [theFileName, theDataString] of Object.entries(theJsonStringObject)) {
		try {
			const theFileBlob = new Blob([theDataString], {
				type: 'application/json'
			});
			const theUrl = URL.createObjectURL(theFileBlob);

			theLink.href = theUrl;
			theLink.download = `${theFileName}.json`;
			theLink.click();

			URL.revokeObjectURL(theUrl);
		} catch (error) {
			console.log(`Failed to download ${theFileName}.json:`, error);
			errors.push(error);
		}
	}
	return {
		didSucceed: errors.length === 0,
		errorArray: errors
	};
};

function downloadAsCSV(dataArray, filename = 'Tuplo.csv') {
	const errors = [];
	try {
		if (!Array.isArray(dataArray)) {
			throw new Error('Provided data is not an array.');
		}

		if (!dataArray.length) {
			console.warn('No data to export.');
			return;
		}

		// Extract headers safely
		const headers = Object.keys(dataArray[0]);
		if (!headers.length) {
			throw new Error('Data objects are missing keys.');
		}

		// Build CSV rows
		const rows = dataArray.map((obj, index) => {
			try {
				return headers.map((header) => `"${(obj[header] ?? '').toString().replace(/"/g, '""')}"`).join(',');
			} catch (rowError) {
				console.error(`Error processing row ${index}:`, rowError);
				errors.push(rowError);
				return headers.map(() => '""').join(','); // fallback to blank row
			}
		});

		const csvContent = [headers.join(','), ...rows].join('\n');

		// Trigger download
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	} catch (error) {
		console.error('CSV export failed:', error);
		errors.push(error);
	}
	return {
		didSucceed: errors.length === 0,
		errorArray: errors
	};
}

const getColorScheme = (() => {
	let cachedScheme = null;

	return () => {
		if (cachedScheme) {
			return cachedScheme;
		}

		if (typeof window.matchMedia !== 'function') return 'lightMode';

		cachedScheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'darkMode' : 'lightMode';

		return cachedScheme;
	};
})();

/**
 * Checks if a string contains potentially harmful tags or characters.
 *
 * @param {string} str - The input string to be checked.
 * @param {boolean} isPassword - Flag indicating whether the string is a password (default: false).
 * @returns {boolean} - True if the string contains harmful tags or characters, false otherwise.
 */
const hasTags = (str) => {
	// const scripts = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>|[<>]/gi; IDK why but this gets rid of the linting issue
	const scripts = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>|<script\b[^>]*?>|[<>]/gi; //checks for '< ?php>' and <script>

	return scripts.test(str);
};

const storageService = {
	setItem(key, value) {
		localStorage.setItem(key, JSON.stringify(value));
	},
	getItem(key, defaultValue = null) {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : defaultValue;
		} catch (error) {
			console.error(`Error retrieving ${key} from localStorage:`, error);
			return defaultValue;
		}
	}
};

//   keys.forEach((key) => {
//     const file = new Blob([jsonStringObject[key]], {type: "text/plain"});

//     a.href = URL.createObjectURL(file);
//     a.download = `${key}.json`;
//     a.click();
//   });
//};
// async function isUsernameUnique(theIDCustomer,theEmail) {
//     let theJSON = document.getElementById("theJSON").value.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'); // replace curly quotes
//     let theURL = document.getElementById("theURL").value;

//     try {
//         let result = await fetch(theURL, {
//             method: 'POST',
//             body: {"myEmail": theEmail},
//             headers: {"Content-type": "application/json; charset=UTF-8"}
//             });

//     let theText = await result.text();
//     let theStatus = await result.status;
// }

// async function doObjectFunction(theObject,theFunction) {
//     console.log(theObject);
//     console.log(theFunction);

//     // let theJSON = document.getElementById("theJSON").value.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'); // replace curly quotes
//     let theURL = 'thinkserver-v7.2.test/TKCustomer/isUsernameUnique';

//     try {
//         let result = await fetch(theURL, {
//             method: 'POST',
//             body: theObject,
//             headers: {"Content-type": "application/json; charset=UTF-8"}
//             });
//     } catch (error) {
//         console.log(error);
//     }
//     // let theText = await result.text();
//     // let theStatus = await result.status;
// }

// async function postJSON(theClass,theObject,theFunction,theParams = '""') {

//     let theJSON = '{"class": "'+theClass+'","function":"'+theFunction+'","object":'+JSON.stringify(theObject)+',"params":'+JSON.stringify(theParams)+'}';

//     try {
//         let result = await fetch('/webhooks/js-call.php', {
//             method: 'POST',
//             body: theJSON,
//             headers: {"Content-type": "application/json; charset=UTF-8"}
//             });

//         let theText = await result.json();
//         let theStatus = await result.status;

//         return theText;

//     } catch (error) {
//         return error;
//     }
// }
